export default __webpack_public_path__ + "static/media/avatar.9e8bc3e6.svg";